<div class="flex flex-row items-center gap-4">
    <button class="primary-btn my-4" (click)="addNewSite()">Add Social Page or Site</button>
</div>

<mat-table [dataSource]="dataSource" matSort class="!w-full !inline-table table-alternate">

    <ng-container matColumnDef="ID">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
        <td mat-cell *matCellDef="let element">
            {{ element.ID }}
        </td>
    </ng-container>

    <ng-container matColumnDef="Domain">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Domain</th>
        <td mat-cell *matCellDef="let element">
            <div class="hover:text-blue-800 hover:underline cursor-pointer" (click)="editSite(element)">
                {{ element.Domain }}
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="platform">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Platform</th>
        <td mat-cell *matCellDef="let element">{{ element.platform }}</td>
    </ng-container>

    <ng-container matColumnDef="siteUrl">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Site Url</th>
        <td mat-cell *matCellDef="let element">{{ element.siteUrl }}</td>
    </ng-container>

    <ng-container matColumnDef="social_media_id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Social Media ID</th>
        <td mat-cell *matCellDef="let element">{{ element.social_media_id }}</td>
    </ng-container>

    <ng-container matColumnDef="access_token">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Access Token</th>
        <td mat-cell *matCellDef="let element" class="max-w-xs truncate">{{ element.access_token }}</td>
    </ng-container>

    <ng-container matColumnDef="isApproved">
        <th mat-header-cell *matHeaderCellDef class="text-center">Actions</th>
        <td mat-cell *matCellDef="let element">
            <mat-form-field appearance="outline" class="w-40 mt-3">
                <mat-select [(ngModel)]="element.isApproved" (selectionChange)="onStatusChange(element)"
                    class="flex justify-center">
                    <mat-option *ngIf="element.isApproved === 'Pending'" value="Pending">Pending</mat-option>
                    <mat-option value="Approved">Approved</mat-option>
                    <mat-option value="Not Approved">Not Approved</mat-option>
                </mat-select>
            </mat-form-field>
        </td>
    </ng-container>

     <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>Delete</th>
    <td mat-cell *matCellDef="let element">
      <button mat-icon-button (click)="$event.stopPropagation();openDeleteSiteConfirm(element)"
        class="!bg-red-500 !text-white">
        <mat-icon>delete</mat-icon>
      </button>
    </td>
  </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</mat-table>

<mat-paginator [length]="totalItems" [pageSize]="12"  showFirstLastButtons>
</mat-paginator>

<ng-template #siteFormTmpl let-dialogData="data">
    <app-site-form [formData]="selectedSite" (onSubmitClbk)="onSubmitClbk()">
    </app-site-form>
</ng-template>


<ng-template #confirmDeleteSiteTmpl>
    <div class="flex flex-col gap-4">
        <p>Are you sure you want to delete <b>{{ selectedSite.Domain }}</b>?</p>
        <div class="flex flex-row items-center justify-center gap-2">
            <button mat-button (click)="deleteSite()">Confirm</button>
            <button mat-button (click)="dialog.closeAll();">Cancel</button>
        </div>
    </div>
</ng-template>